
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/agillic",
      function () {
        return require("private-next-pages/destinations/agillic.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/agillic"])
      });
    }
  